import React, { useState, useEffect } from 'react'

export const PortraitPicture = ({ id }) => {
  const placeHolderUrl = require('./image.png')
  // const portraitUrl = `https://dev-interactif.24heures.ch/2021/300plusriches/images/${id}.jpg`
  const image = new Image()
  const [url, setUrl] = useState(placeHolderUrl)

  useEffect(() => {
    if (id) {
      const portraitUrl = require(`../../images/portraits/${id}.jpg`)
      image.src = portraitUrl
      image.onload = () => {
        setUrl(portraitUrl)
      }
    }
  }, [])

  return (
    <div className='picture-container'>
      <div
        className='picture'
        style={{
          backgroundImage: `url(${url})`
        }}
      />
    </div>
  )
}
